<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">会社作成</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form-company
              :submitType="submitType"
              :submitString="submitString"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormCompany from '../../../components/FormComponents/Company'

export default {
  components: {
    FormCompany,
  },
  data() {
    return {
      submitType: 'post',
      submitString: '作成',
    }
  },
  created() {
  },
}
</script>

<style>
.list-name {
  font-size: 1.5rem;
}
</style>
